import { render, staticRenderFns } from "./static-form-renderer.vue?vue&type=template&id=13a51bf2"
import script from "./static-form-renderer.vue?vue&type=script&lang=js"
export * from "./static-form-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports